import * as THREE from 'three'
// import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'

import Experience from './Experience.js'

export default class Camera {
  constructor () {
    this.experience = new Experience()
    this.sizes = this.experience.sizes
    this.scene = this.experience.scene
    this.canvas = this.experience.canvas
    this.debug = this.experience.debug

    this.setInstance()
    //  this.setControls()
    this.setGUI()
  }

  setInstance () {
    this.instance = new THREE.PerspectiveCamera(35, this.sizes.width / this.sizes.height, 0.01, 1000000)
    this.instance.position.set(0, 0, 1700)
    this.instance.lookAt(0, 0, 0)
    this.scene.add(this.instance)
  }

  setGUI () {
    this.debugFolder = this.debug.ui.addFolder('Scene')
    this.debugFolder.add(this.instance.parent.position, 'x').min(-5000).max(5000).step(1)
    this.debugFolder.add(this.instance.parent.position, 'y').min(-5000).max(5000).step(1)
    this.debugFolder.add(this.instance.parent.position, 'z').min(-5000).max(5000).step(1)

    this.debugFolder.add(this.instance.parent.rotation, 'x').min(0).max(Math.PI * 2).step(1)
    this.debugFolder.add(this.instance.parent.rotation, 'y').min(0).max(Math.PI * 2).step(1)
    this.debugFolder.add(this.instance.parent.rotation, 'z').min(0).max(Math.PI * 2).step(1)

    this.cameraFolder = this.debug.ui.addFolder('Camera')
    this.cameraFolder.add(this.instance.position, 'x').min(-5000).max(5000).step(1).onFinishChange(() => { console.log(this.instance.position) })
    this.cameraFolder.add(this.instance.position, 'y').min(-5000).max(5000).step(1).onFinishChange(() => { console.log(this.instance.position) })
    this.cameraFolder.add(this.instance.position, 'z').min(-5000).max(5000).step(1).onFinishChange(() => { console.log(this.instance.position) })

    this.cameraFolder.add(this.instance.rotation, 'x').min(0).max(Math.PI * 2).step(1)
    this.cameraFolder.add(this.instance.rotation, 'y').min(0).max(Math.PI * 2).step(1)
    this.cameraFolder.add(this.instance.rotation, 'z').min(0).max(Math.PI * 2).step(1)
  }

  setControls () {
    console.log(this.instance)
    // this.controls = new OrbitControls(this.instance, this.canvas)
    console.log(this.instance)

    // this.controls.enableDamping = true
  }

  resize () {
    this.instance.aspect = this.sizes.width / this.sizes.height
    this.instance.updateProjectionMatrix()
  }

  setCamera (camera) {
  //  const temp = this.instance

    //   this.instance = camera

    this.instance.position.copy(camera.parent.position)
    this.instance.quaternion.copy(camera.parent.quaternion)
    this.instance.scale.copy(camera.parent.scale)

    this.instance.position.set(0, 0, 1700)
    //  this.controls = new OrbitControls(this.instance, this.canvas)
    this.instance.far = 100000000

    // this.controls.target = new THREE.Vector3(0, 0, 0)

    /*   this.instance.parent.lookAt(0, 0, 0)
    this.instance.lookAt(0, 0, 0) */

    /*   this.instance.fov = temp.fov
    this.instance.aspect = temp.aspect
    this.instance.parent.fov = temp.fov
    this.instance.parent.aspect = temp.aspect */
  }

  update () {
    //  this.controls.update()
    this.instance.updateMatrix()
  }
}
